class CustomTabs extends HTMLElement {
    constructor() {
        super();
        this.btns = Array.from(this.querySelectorAll('.tab-btn'));
        this.contents = this.querySelectorAll('.tab-content');
        
        this.changeActive(0);

        this.btns.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                this.changeActive(index);
            });
        });
    }

    changeActive(index) {

        if(!this.contents[index]) return;

        this.btns.forEach(btn => btn.classList.remove('active'));
        this.contents.forEach(content => content.classList.remove('active'));

        this.btns[index].classList.add('active');
        this.contents[index].classList.add('active');
    }
}

customElements.define('custom-tabs', CustomTabs);